module.exports = __webpack_public_path__ + "assets/img/1dbf-jp.svg";